<template>
    <div class="row mt-5">
        <div class="col-md-2">
            <aside>
                <h3 class="nav-heading ">
                    Reports
                </h3>
                <ul class="nav flex-column mb-4">
                    <li class="nav-item">
                        <a class="nav-link active">Quote</a>
                    </li>
                </ul>
            </aside>
        </div>

        <div class="col-md-10 align-col-titles">
            <div class="flex w-full flex-row flex-wrap flex-xl-nowrap quoteFields">
                <div class="mainquotefield">
                    <label class="text-sm text-grey-darkest">Category</label>
                    <multiselect class="cursor-pointer" v-model="quotaSearchFilter.category_id" :options="allPGCategories"
                                 :show-labels="false" track-by="id" label="name" :multiple="true"></multiselect>
<!--                    <treeselect v-model="quotaSearchFilter.category_id" :options="allPGCategories"/>-->
                </div>
                <div class="mainquotefield">
                    <label class="text-sm text-grey-darkest">Products & Service</label>
                    <multiselect class="cursor-pointer" v-model="product_id" :options="allProductService"
                                 :show-labels="false" track-by="id" label="name" :multiple="true"></multiselect>
<!--                    <treeselect v-model="quotaSearchFilter.category_id" :options="allPGCategories"/>-->
                </div>
                <div class="mainquotefield">
                    <label class="text-sm text-grey-darkest">Products Custom Fields</label>
                    <multiselect class="cursor-pointer" v-model="product_customfield_id" :options="allProductServiceCustomFields"
                                 :show-labels="false" track-by="id" label="name" :multiple="true"></multiselect>
<!--                    <treeselect v-model="quotaSearchFilter.category_id" :options="allPGCategories"/>-->
                </div>
                <div class="mainquotefield">
                    <label class="text-sm text-grey-darkest">Products Custom Fields Option</label>
                    <multiselect class="cursor-pointer" v-model="product_customfield_option_id"  :options="allProductServiceCustomFieldOptionValues"
                                 :show-labels="false" track-by="id" label="name" :multiple="true"></multiselect>
<!--                    <treeselect v-model="quotaSearchFilter.category_id" :options="allPGCategories"/>-->
                </div>
                <div class="mainquotefield">
                    <label class="text-sm text-grey-darkest">Quote Sent Date</label>
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span
                                class="input-group-text text-sm cursor-pointer hover:bg-grey hover:text-white text-grey-darkest"
                                @click="openDateRangePickerButton"><i
                                class="fa fa-calendar" aria-hidden="true"></i></span>
                        </div>
                        <input type="text" ref="daterange"
                               class="form-control"
                               :value="selectedDate ? selectedDate.startDate  +' - '+ selectedDate.endDate : ' '"
                               @focus="openDateRangePicker"/>

                        <div class="input-group-append">
                        <span class="input-group-text cursor-pointer hover:bg-grey hover:text-white text-grey-darkest">
                            <i class="material-icons text-sm" @click.stop="clearDates">clear</i>
                        </span>
                        </div>
                    </div>
                </div>
                <div class="mainquotefield" style="position: relative">
                    <div class="main-dropdown-slider">
                        <label>Select Range</label>
                        <input type="text" class="valued-range-slider form-control" :value="minValue+'-'+maxValue"  @click="openRangePicker" readonly>
                    </div>
                    <div id="range-slider-toggle" class="d-none main-align-range-slider">
                        <div class="wrapper main-range-slider">
                            <div class="slider">
                                <div class="progress" :style="{ left: leftPosition, right: rightPosition }"></div>
                            </div>
                            <div class="range-input">
<!--                                <input type="range" class="range-min" min="0" :max="maxRange"  step="100" v-model="min">
                                <input type="range" class="range-max" min="0" :max="max"  step="100"  v-model="max">-->
                                <input type="range" class="range-min" min="0" :max="maxRange" v-model="minValue" step="100">
                                <input type="range" class="range-max" min="0" :max="maxRange" v-model="maxValue" step="100">
                            </div>
                            <div class="price-input prices-align-main">
                                <div class="field">
                                    <input type="number" class="input-min" v-model="minPrice">
                                </div>
                                <p>to</p>
                                <div class="field">
                                    <input type="number" class="input-max" v-model="maxPrice">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mainquotefield">
                    <label class="text-sm text-grey-darkest">Signed?</label>
                    <multiselect class="cursor-pointer" v-model="quotaSearchFilter.signed" :options="signedOptions"
                                 :show-labels="false" track-by="id" label="name" :multiple="true"></multiselect>
                </div>
                <div class="mainquotefield">
                    <label class="text-sm text-grey-darkest">Proposal Sender</label>
                    <multiselect class="cursor-pointer" v-model="quotaSearchFilter.proposalSender" :options="users"
                                 :show-labels="false" track-by="id" label="name" :multiple="true"></multiselect>
                </div>
                <div class="mainquotefield">
                    <label class="text-sm text-grey-darkest">Sales Status</label>
                    <multiselect class="cursor-pointer" v-model="sales_status_id" :options="sales_status"
                                 :show-labels="false" track-by="id" label="name" :multiple="true"></multiselect>
                </div>
            </div>
            <div class="pull-right">
                <button @click="generateReport"
                        class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-3 rounded-full text-followup-nav"
                        type="button">
                    Get Report
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Mixin from './mixin';
import Treeselect from "@riophae/vue-treeselect";
import Datepicker from 'vuejs-datepicker';
import Multiselect from 'vue-multiselect';
import moment from 'moment';
import 'daterangepicker/daterangepicker.css';
import 'daterangepicker';
import Form from "../../utils/form";

export default {
    mixins: [Mixin],
    name: 'quotes-report',
    props: ['filter-uri', 'is-pm', 'userRole', 'team', 'maxQuoteAmount', 'minQuoteAmount', 'activeUsers'],
    components: {Treeselect, Multiselect},
    data() {
        return {
            minPrice: (this.minQuoteAmount)? this.minQuoteAmount:0,
            maxPrice: (this.maxQuoteAmount)? this.maxQuoteAmount:1000,
            minValue: (this.minQuoteAmount)? this.minQuoteAmount:0,
            maxValue: (this.maxQuoteAmount)? this.maxQuoteAmount:1000,
            maxRange: (this.maxQuoteAmount)? this.maxQuoteAmount:1000,
            priceGap: 1000,
            min:(this.minQuoteAmount)? this.minQuoteAmount:0,
            max:(this.maxQuoteAmount)? this.maxQuoteAmount:1000,
            allPGCategories: [],
            allProductService: [],
            allProductServiceCustomFields: [],
            allProductServiceCustomFieldOptionValues: [],
            rangePicker: '',
            selectedDate: {
                startDate: moment().format('MM/DD/YYYY'),
                endDate: moment().add(30, 'days').format('MM/DD/YYYY'),
            },
            product_id:null,
            product_customfield_id:null,
            product_customfield_option_id:null,
            sales_status : [],
            sales_status_id:null,
            quotaSearchFilter: {
                category_id: null,
                date: null,
                singed: [],
                proposalSender: []
            },
            signedOptions: [
                {
                    id: 1,
                    name: 'Yes'
                },
                {
                    id: 2,
                    name: 'No'
                },
                {
                    id: 3,
                    name: 'Both'
                },
            ],
            users: [
                {
                    id: 1,
                    name: 'Dev User'
                },
                {
                    id: 2,
                    name: 'Jonathan'
                },
                {
                    id: 3,
                    name: 'Brad Hopper'
                }
            ],
            selectedRange: ''
        }
    },
    computed: {
        leftPosition() {
            return `${(this.min / 10000) * 100}%`;
        },
        rightPosition() {
            return `${100 - (this.max / 10000) * 100}%`;
        }
    },
    mounted() {
        let vue = this;
        const rangeInput = document.querySelectorAll(".range-input input"),
            priceInput = document.querySelectorAll(".price-input input"),
            range = document.querySelector(".slider .progress");
        let priceGap = 1000;
        priceInput.forEach((input) => {
            input.addEventListener("input", (e) => {
                let minPrice = parseInt(priceInput[0].value),
                    maxPrice = parseInt(priceInput[1].value);
                if (maxPrice - minPrice >= priceGap && maxPrice <= rangeInput[1].max) {
                    if (e.target.className === "input-min") {
                        rangeInput[0].value = minPrice;
                        range.style.left = (minPrice / rangeInput[0].max) * 100 + "%";
                    } else {
                        rangeInput[1].value = maxPrice;
                        range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + "%";
                    }
                }
                vue.rangePicker = minPrice+'-'+maxPrice;
            });
        });
        rangeInput.forEach((input) => {
            input.addEventListener("input", (e) => {
                let minVal = parseInt(rangeInput[0].value),
                    maxVal = parseInt(rangeInput[1].value);

                if (maxVal - minVal < priceGap) {
                    if (e.target.className === "range-min") {
                        rangeInput[0].value = maxVal - priceGap;
                    } else {
                        rangeInput[1].value = minVal + priceGap;
                    }
                } else {
                    priceInput[0].value = minVal;
                    priceInput[1].value = maxVal;
                    range.style.left = (minVal / rangeInput[0].max) * 100 + "%";
                    range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + "%";
                }
            });
        });
        this.users = this.activeUsers.map(obj => ({ id: obj.id, name: obj.name }));
        this.getAllPGCategories();
        this.getAllProductServices(0);
        this.getSalesStatus();
    },
    watch: {
        'quotaSearchFilter.category_id':{
            handler: function (val, oldVal) {
                let filteredCategories =  val.map(category => category.id);
                this.product_id = null;
                if(filteredCategories.length === 0){
                    filteredCategories = 0;
                }
                this.getAllProductServices(filteredCategories);
            },
            deep: true
        },
        product_id: {
            handler: function (val, oldVal) {
                const filteredCategories =  val.map(category => category.id);
                this.product_customfield_id = null;
                this.product_customfield_option_id = null;
                this.customfields(filteredCategories);
            },
            deep: true
        },
        product_customfield_id: {
            handler: function (val, oldVal) {
                this.product_customfield_option_id = null;
                const filteredCategories =  val.map(category => category.id);
                this.customFieldOption(filteredCategories);
            },
            deep: true
        },
        minPrice(value) {
            if (value < this.minValue) {
                this.minValue = value;
            }
        },
        maxPrice(value) {
            if (value > this.maxValue) {
                this.maxValue = value;
            }
        },
        minValue(value) {
            this.minValue = Math.max(value, 0);
            this.updateRange();
        },
        maxValue(value) {
            this.maxValue = Math.min(value, this.maxRange);
            this.updateRange();
        },
    },
    methods: {
        customfields(filteredCategories){
            let self = this;
            axios.post(route('api.proposal-settings.category.get-all-productservices-customfield'),{product_id:filteredCategories}).then(response => {
                this.allProductServiceCustomFields = response.data.allProductCustomFields;
                this.allProductServiceCustomFieldOptionValues = [];
            });
        },
        customFieldOption(filteredCategories){
            let self = this;
            axios.post(route('api.proposal-settings.category.get-all-productservices-customfield-options'),{product_option_id:filteredCategories}).then(response => {
                this.allProductServiceCustomFieldOptionValues =   response.data.allProductCustomFieldOption;
            });
        },
        getAllProductServices(filteredCategories) {
            let self = this;
            axios.post(route('api.proposal-settings.category.get-all-productservices'),{category_id:filteredCategories}).then(response => {
                this.allProductService = response.data.allProduct;
            });
        },
        updateRange() {
            this.minValue = Math.max(this.minValue, 0);
            this.maxValue = Math.min(this.maxValue, this.maxRange);
        },
        openRangePicker() {
            $('#range-slider-toggle').toggleClass('show-range-slider');
        },
        clearDates() {
            this.selectedDate = null;
        },
        openDateRangePicker() {
            let self = this;
            $(this.$refs.daterange).daterangepicker({
                opens: 'center',
                autoApply: true,
                showDropdowns: true,
                locale: {
                    format: 'MM/DD/YYYY'
                }
            }, function (start, end, label) {
                self.selectedDate = {
                    startDate: moment(start).format('MM/DD/YYYY'),
                    endDate: moment(end).format('MM/DD/YYYY')
                }
            });
        },
        openDateRangePickerButton() {
            this.$nextTick(() => {
                this.$refs.daterange.focus();
            });
        },
        quoteValSetting(val, proposalDates) {
            this.filterUri = this.filterUri || '';
            const existingParams = this.filterUri.split('&').reduce((acc, param) => {
                const [key, value] = param.split('=');
                acc[key] = value;
                return acc;
            }, {});
            if (val.category_id === undefined) {
                existingParams.category_id = null;
            }
            if (val.signed) {
                existingParams.signed = JSON.stringify(val.signed);
            }
            if (val.proposalSender) {
                existingParams.proposalSender = JSON.stringify(val.proposalSender);
            }
            if (val.category_id) {
                existingParams.category_id = JSON.stringify(val.category_id);
            }
            if (proposalDates == null) {
                existingParams.proposalStartDate = '';
                existingParams.proposalEndDate = '';
            }
            if (proposalDates !== null) {
                existingParams.proposalStartDate = this.selectedDate.startDate;
                existingParams.proposalEndDate = this.selectedDate.endDate;
            }

            this.filterUri = Object.entries(existingParams)
                .map(([key, value]) => `${key}=${value}`)
                .join('&');

        },
        getAllPGCategories() {
            let self = this;
            axios.post(route('api.proposal-settings.category.get-all-categories')).then(response => {
                this.allPGCategories =  response.data.allCategories.map(category => ({
                    id: category.id,
                    name: category.label
                }));
            });
        },
        getSalesStatus() {
            let self = this;
            axios.post(route('api.proposal-settings.category.getSalesStatus')).then(response => {
                console.log('response', response)
                this.sales_status = response.data.allSalesStatus;
            });
        },
        generateReport() {
            this.quoteValSetting(this.quotaSearchFilter, this.selectedDate);
            this.filterUri += "&excel=true&name=proposal quote report&min="+this.minValue+"&max="+this.maxValue+"&product_id="+JSON.stringify(this.product_id)+"&product_customfield_id="+JSON.stringify(this.product_customfield_id)+"&product_customfield_option_id="+JSON.stringify(this.product_customfield_option_id)+"&sales_status_id="+JSON.stringify(this.sales_status_id);
            console.log(' this.filterUri', this.filterUri);
            window.location = route('reports-charts.get-quotes-excel') + this.filterUri;
        }
    }
};
</script>

<style lang="scss" escoped>
.schedule-modal {
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0px 0px 10px 3px #333;
}

#scheduleReport .modal-dialog {
    top: 8vh;
}

.wrapper {
    width: 300px;
    background: #fff;
    border-radius: 4px;
    padding-top: 20px;
    border: 1px solid #dae1e7;
}

.align-col-titles .w-1\/4.mr-4 label {
    min-height: 42px;
    display: flex;
    align-items: center;
}

.price-input {
    margin: 20px 0;
    display: flex;
    justify-content: flex-end;
}

.price-input .field {
    width: fit-content;
}

.field:first-child input {
    text-align: right;
}

.field input {
    border: 0;
    -moz-appearance: textfield;
    width: fit-content;
    max-width: 120px;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

.price-input .separator {
    width: 130px;
    display: flex;
    font-size: 19px;
    align-items: center;
    justify-content: center;
}

.slider {
    height: 5px;
    position: relative;
    background: #ddd;
    border-radius: 5px;
    overflow: hidden;
}

.slider .progress {
    height: 100%;
    left: 25%;
    right: 25%;
    position: absolute;
    border-radius: 5px;
    background: #17a2b8;
}

.range-input {
    position: relative;
}

.range-input input {
    position: absolute;
    width: 100%;
    height: 5px;
    top: -5px;
    background: none;
    pointer-events: none;
    -webkit-appearance: none;
    -moz-appearance: none;
}

input[type="range"]::-webkit-slider-thumb {
    height: 17px;
    width: 17px;
    border-radius: 50%;
    background: #17a2b8;
    pointer-events: auto;
    -webkit-appearance: none;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.05);
}

input[type="range"]::-moz-range-thumb {
    height: 17px;
    width: 17px;
    border: none;
    border-radius: 50%;
    background: #17a2b8;
    pointer-events: auto;
    -moz-appearance: none;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.05);
}

.main-align-range-slider.show-range-slider {
    display: block !important;
    position: absolute;
    z-index: 9;
    left: 0;
}
.quoteFields{
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-gap: 1rem;
}

</style>
